import React, { Component } from "react"
import { withStyles } from "@mui/styles"
import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"

const styles = theme => ({
  message: {
    fontSize: 14,
    // fontWeight: "bold",
    paddingTop: 20,
  },
  box: {
    width: 100,
    margin: "auto",
  },
  progress: {
    opacity: "50%",
  }
})

class GettingData extends Component {

  render() {
    const { classes } = this.props

    return (
      <Box className={classes.box}>

        {/* <Typography className={classes.message}>
          Getting data
        </Typography> */}

        <CircularProgress className={classes.progress} />

      </Box>
    )
  }
}

export default withStyles(styles)(GettingData);